import React, { useContext, useState } from 'react'

import CloseIcon from '@mui/icons-material/Close'
import Rating from '@mui/material/Rating';
import { Avatar, Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import DetectDevice from '../../context/DetectDevice';
import { Dropdown, Toast } from 'react-bootstrap';
import axios from 'axios';
import ENDPOINT from '../../context/EndPoint';
import SecurityHeaders from '../../context/SecurityHeaders';

import ModalStyle from '../../context/ModalStyle';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import ScheduleInterview from './ScheduleInterview';
import { AuthContext } from '../../context/AuthContext';
import { useDispatch } from 'react-redux';
  
const CandidateItem = ({item}) => {
  const dispatch = useDispatch()
  const [schedule,setschedule] = useState(false)
  const [addtask,setaddtask] = useState(false)
  const [notification,setnotification] = useState(false)
  const [internshipid,setinternshipid] = useState(null)
const device = DetectDevice()
console.log(device)
  const { user } = useContext(AuthContext);

  const updateInternship = async ({ iid, istatus }) => {
    dispatch({ type: 'LOADING' });
  
    const data = new FormData();
    data.append('session', user.SessionId);
    data.append('application_id', iid);
    data.append('internship_status', istatus);
  
    try {
      const res = await axios.post(
        `${ENDPOINT}update-intern-status.php`,
        data,
        SecurityHeaders
      );
  
      if (res?.data) {
        if (res.data.status === "success") {
          dispatch({ type: 'DONE_LOADING' });
          settoasttitle(`Application ${istatus} ${iid}`);
          settoastmessage("Successful");
          settoast(true);
        } else {
          dispatch({ 
            type: 'ERROR', 
            payload: res.data.message || 'Failed to update internship status' 
          });
        }
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: 'Invalid response format' 
        });
      }
    } catch (error) {
      dispatch({ 
        type: 'ERROR', 
        payload: error.message || 'An error occurred while updating internship status' 
      });
    }
  };
    const [toast,settoast] = useState(false)
    const [toasttitle,settoasttitle] = useState(null)
    const [toastmessage,settoastmessage] = useState(null)
    const [currentintern,setcurrentintern] = useState(null)
    const [interview,setinterview]= useState(false)
  return (
    <>
    <Modal
  open={interview}
  onClose={()=>{setinterview(false)}}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box  className="p-3 col-lg-4 col-md-5 col-12 rounded" sx={ModalStyle}>
   <>
   <div className="flex  justify-content-between">
     <h4>Schedule Interview</h4>
     <CloseIcon type="button" onClick={()=>setinterview(false)}/>
     </div>
     <hr></hr>
<ScheduleInterview item={item} intern_id={item.user_id}/>
   </>
  </Box>
</Modal>

<div key={item.id} className="position-fixed container-fluid left-0 bottom-60 justify-center">
<Toast className="bg-warning" show={toast} onClose={()=>{settoast(false)}} autohide={true} delay={5000}>
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">{toasttitle}</strong>
            
          </Toast.Header>
          <Toast.Body>{toastmessage}</Toast.Body>
        </Toast>
</div>
    {device==="mobile"?
    <>
        <div className="card mb-0 p-2">       
              <div className="card-body">
                  
                  <div className="d-lg-flex align-items-center">
                    
                  
                    <div className=" mb-2 my-lg-0">
                      
                     <div className="d-flex">
                     <Link to="/students/" className='d-flex'>
                      <Avatar className='me-2 ' src={item.profile_pic}/>
                      <div>
                        <h5 className="fs-16 m-0">{item.first_name+" "+item.last_name}</h5>
                        <div>
                        <span className="badge bg-warning text-light">
                            Good Match
                          </span>
                        </div>
                      </div>
                      </Link>
                     </div>


                      <div className="d-flex align-items-center">
                      <div>
                      <p className="text-muted mb-0 me-3">{item.title}</p>
                      </div>
                      </div>

                      <div className="d-flex">


                      </div>

                    </div>
                      
                      <div className='d-flex justify-content-between align-items-center'>
                        <div>
                          <i className="ri-time-line text-primary me-1 align-bottomr" />
                          <span className="badge bg-danger-subtle text-danger">
                            Part Time
                          </span>
                        </div>
                        <div className="d-flex flex-wrap gap-2 align-items-center mx-auto my-lg-0">
                      
                          <div className="badge text-bg-success">
                            
                            <i className="mdi mdi-star me-1" />
                            4.2
                          </div>
                          <div className="text-muted">2.2k Ratings</div>
                        </div>
                        <div>
                          <a href="#!" className="btn btn-ghost-danger btn-icon custom-toggle mt-0" data-bs-toggle="button" aria-pressed="false">
                          
                            <span className="icon-on">
                              <i className="ri-bookmark-line align-bottom" />
                            </span>
                            <span className="icon-off">
                              <i className="ri-bookmark-3-fill align-bottom" />
                            </span>
                          </a>
                        </div>
                      </div>

                  </div>

                  <div className="my-2">
                <div >
                    <h6>COVER LETTER</h6>
                </div>
                <div className='ps-3'>
                {item.reason}
                </div>

                </div>

                <div className="d-flex">

                </div>
                <div className='navbar'>
                  <div className='d-flex mb-0'>
                    <p className='mb-0'>Applied 4 days ago</p>
                  </div>
                  <div>
                  <a href="#!" className="btn btn-soft-success mt-2">
                    View Details
                  </a>
                  </div>
                </div>

                <div class="d-flex col-12 justify-content-between">
                                    <button  onClick={(e)=>{e.preventDefault(); updateInternship({iid:item.id,istatus:"rejected"})}} class="text-danger border-0 p-2 me-"> <b>Not Intrested</b> </button>
                                    <button onClick={(e)=>{e.preventDefault(); updateInternship({iid:item.id,istatus:"shortlisted"})}}  class="text-sucess ml-5 mr-5 border-0 p-2"> <b>Shortlist</b></button>
                        
                                   
                                    <Dropdown class="ml-5 d-none">
                                            <Dropdown.Toggle variant="light" id="dropdown-basic">
                                              Next Steps
      
                                           </Dropdown.Toggle>

                                                   <Dropdown.Menu>
                                       

  <Dropdown.Item  onClick={()=>{setcurrentintern(item.user_id);setinterview(true)}} >Schedule Interview</Dropdown.Item>

    <Dropdown.Item  onClick={()=>{updateInternship({iid:item.id,istatus:"selected"})}} >Select</Dropdown.Item>
    <Dropdown.Item  onClick={()=>{updateInternship({iid:item.id,istatus:"joined"})}}  >Mark Joined</Dropdown.Item>
    <Dropdown.Item  onClick={()=>{updateInternship({iid:item.id,istatus:"completed"})}} >Mark Completed</Dropdown.Item>
    <Dropdown.Item  onClick={()=>{updateInternship({iid:item.id,istatus:"terminated"})}} >Terminate</Dropdown.Item>




<Dropdown.Item  onClick={()=>{setcurrentintern(item.user_id);setinternshipid(item.internship_id);setschedule(true)}} >Schedule Meeting</Dropdown.Item>
  
  <Dropdown.Item  onClick={()=>{setcurrentintern(item.user_id);setnotification(true)}} >Send Notification</Dropdown.Item>



                                                    </Dropdown.Menu>
                                         </Dropdown>

                                </div>
                </div>
                
              </div>
    </>:
    
    <>
      <div className="card mb-0 p-2">
               <div className="d-flex justify-content-between">

               <div className="d-flex">
            <Chip size='small' className='d-flex bg-warning align-items-center' label={<>
            
               <div className="d-flex align-items-center">
              
                      <h6 className='m-0 text-light'>Good Match</h6>
               </div>
            </>}/>
                </div>
                



                <p>Applied 4 days ago</p>
               </div>
                <hr className='my-1'></hr>
                
                <div className="card-body">
                  
                  <div className="d-lg-flex align-items-center">
                    
                  
                    <div className=" mb-2 my-lg-0">
                      
                     <div className="d-flex ">
                     <Link to="/students/" className='d-flex align-items-center'>
                      <Avatar className='me-2 ' src={item.profile_pic}/>
                    <div>
                    <h5 className="fs-16 mb-2">{item.first_name+" "+item.last_name}</h5>
                    {item.internship_id+"-"+item.id}
                    </div>
                      </Link>
                     </div>


                      <div className="d-flex align-items-center">

                      <p className="text-muted mb-0 me-3">{item.title}</p>
   
                      <div>
                        <i className="ri-map-pin-2-line text-muted me-1 align-bottom" />
                 
                      </div>
                      </div>










                      <div className="d-flex">


                      </div>






                    </div>
                    <div className="d-flex gap-4 mt-0 text-muted mx-auto">
                      
                     
                      <div>
                        <i className="ri-time-line text-primary me-1 align-bottom" />
                        <span className="badge bg-danger-subtle text-danger">
                          Part Time
                        </span>
                      </div>
                    </div>
                    <div className="d-flex flex-wrap gap-2 align-items-center mx-auto my-3 my-lg-0">
                      
                      <div className="badge text-bg-success">
                        
                        <i className="mdi mdi-star me-1" />
                        4.2
                      </div>
                      <div className="text-muted">2.2k Ratings</div>
                    </div>
                    <div>
                      
                      <a href="#!" className="btn btn-soft-success">
                        View Details
                      </a>
                      <a
                        href="#!"
                        className="btn btn-ghost-danger btn-icon custom-toggle"
                        data-bs-toggle="button"
                        aria-pressed="false"
                      >
                        
                        <span className="icon-on">
                          <i className="ri-bookmark-line align-bottom" />
                        </span>
                        <span className="icon-off">
                          <i className="ri-bookmark-3-fill align-bottom" />
                        </span>
                      </a>
                    </div>
                  </div>

                  <div className="d-flex my-2">
                <div className="col-2">
                    <h6>COVER LETTER</h6>
                </div>
                <div className="col-10">
                {item.reason}
                </div>

                </div>

                                  <div className="d-flex my-2">
                <div className="col-2">
                    <h6>EXPERIENCE</h6>
                </div>
                <div className="col-10">
                Bachelor of Science (B.Sc), Electronics and Instrumentation (2021 - 2024)
                </div>

                </div>

                <div className="d-flex my-2">
                <div className="col-2">
                    <h6>EDUCATION</h6>
                </div>
                <div className="col-10">
                Bachelor of Science (B.Sc), Electronics and Instrumentation (2021 - 2024)
                </div>

                </div>



                <div className="d-flex my-2">
                <div className="col-2">
                    <h6>SKILLS</h6>
                </div>
                <div className="col-10">

                <div className="d-flex">
                <div className="d-flex me-3 align-items-center">
                <Rating/>
                <h6>HTML</h6>
                </div>


                <div className="d-flex me-2 align-items-center">
                <Rating/>
                <h6>HTML</h6>
                </div>
                </div>
                
                </div>

                </div>


                <div className="d-flex">

                </div>


                </div>

                <div class="d-flex col-12 justify-content-between">
                <a target="_blank" href={item.resume_link} class="text-decoration-none"> Resume</a>

                                
                               
                                
                                    <button  onClick={(e)=>{e.preventDefault(); updateInternship({iid:item.id,istatus:"rejected"})}} class="text-danger border-0 p-2 me-"> <b>Not Intrested</b> </button>
                                    <button onClick={(e)=>{e.preventDefault(); updateInternship({iid:item.id,istatus:"shortlisted"})}}  class="text-sucess ml-5 mr-5 border-0 p-2"> <b>Shortlist</b></button>
                        
                                   
                                    <Dropdown class="ml-5 d-none">
                                            <Dropdown.Toggle variant="light" id="dropdown-basic">
                                              Next Steps
      
                                           </Dropdown.Toggle>

                                                   <Dropdown.Menu>
                                       

  <Dropdown.Item  onClick={()=>{setcurrentintern(item.user_id);setinterview(true)}} >Schedule Interview</Dropdown.Item>

    <Dropdown.Item  onClick={()=>{updateInternship({iid:item.id,istatus:"selected"})}} >Select</Dropdown.Item>
    <Dropdown.Item  onClick={()=>{updateInternship({iid:item.id,istatus:"joined"})}}  >Mark Joined</Dropdown.Item>
    <Dropdown.Item  onClick={()=>{updateInternship({iid:item.id,istatus:"completed"})}} >Mark Completed</Dropdown.Item>
    <Dropdown.Item  onClick={()=>{updateInternship({iid:item.id,istatus:"terminated"})}} >Terminate</Dropdown.Item>




  <Dropdown.Item  onClick={()=>{setcurrentintern(item.user_id);setnotification(true)}} >Send Notification</Dropdown.Item>



                                                    </Dropdown.Menu>
                                         </Dropdown>

                                </div>
              </div>
    </>}
            
    </>
  )
}

export default CandidateItem